import { render } from "./DecoresMMPage.vue?vue&type=template&id=b6083816"
import script from "./DecoresMMPage.vue?vue&type=script&lang=js"
export * from "./DecoresMMPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__